<template>
  <div class="mirrors-configs-tab">
    <v-card
      v-for="(mirror, index) in mirrorsList"
      :key="mirror.settings_id"
      class="mirrors-configs-tab__item mb-2 mt-2"
      outlined
      @click="$emit('select-mirror', mirror)"
    >
      <div class="mirrors-configs-tab__content px-4">
        <div class="body-2 mirrors-configs-tab__name">
          <span class="font-weight-medium">
          #{{ index + 1 }} Mirror:
          </span>
          {{ mirror.mirror_name }}
        </div>


        <div v-if="hasTags(mirror)" class="d-flex align-center mirrors-configs-tab__tags">
          <span class="body-2 mr-3">Custom settings</span>
          <div class="d-flex align-center flex-wrap">
            <v-chip
              v-for="tag in mirror.tags"
              :key="tag"
              outlined
              color="warning"
              class="mr-1 mirrors-configs-tab__pill-chip"
            >
              {{ tagLabel(tag) }}
            </v-chip>
          </div>
        </div>
        <div v-else class="d-flex align-center mirrors-configs-tab__tags">
          <span class="body-2">Domain settings (default)</span>
        </div>


        <v-icon small color="grey" class="mirrors-configs-tab__icon">mdi-chevron-right</v-icon>
      </div>
    </v-card>

    <div v-if="!loading && mirrorsList.length === 0" class="pa-6 grey--text text-center caption">
      No mirrors configured
    </div>
  </div>
</template>

<script>
  import { TAG_LABELS } from '@/modules/feature-config/constants/const'

  export default {
    name: 'MirrorsConfigsTab',
    data: () => ({
      tagLabels: TAG_LABELS
    }),
    props: {
      project: {
        type: Number,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      mirrorsList: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      hasTags (mirror) {
        return Array.isArray(mirror.tags) && mirror.tags.length > 0
      },
      tagLabel (tag) {
        return this.tagLabels[tag] || tag
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mirrors-configs-tab {
    &__item {
      cursor: pointer;
      border-style: dashed !important;
      height: 72px;
      align-items: center;
      display: flex;

      &:hover {
        background-color: #f5f5f5;
      }
    }

    &__content {
      display: flex;
      align-items: center;
      width: 100%;
    }

    &__name {
      width: 25%;
      flex-shrink: 0;
    }

    &__tags {
      flex: 1;
      margin-left: auto;
      margin-right: auto;
    }

    &__icon {
      flex-shrink: 0;
      margin-left: auto;
    }

    &__pill-chip {
      height: 24px;
      min-height: 24px;
      padding: 5px 8px;
      border-radius: 50px;
      font-size: 12px;
    }
  }
</style>
